export default __webpack_public_path__ + "static/uwt.f00e269b4e47f8ba436bc6b5f25117d4.png";